let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("1Q0fy")).then(() => parcelRequire('liA2E'));